module.exports = __webpack_public_path__ + "static/media/fig_13b.12988c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13b.jpg
// module id = 634
// module chunks = 0